/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
import React, { InputHTMLAttributes, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { MAX_FILE_SIZE } from '../../constants';
import { MainButton } from '../MainButtons/MainButton';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  error?: string;
  showError?: boolean;
  changeImage: (field: string, value: string) => void;
  setErrorFromImage: (message: string) => void;
}

export const UploadImage = ({
  error,
  showError,
  changeImage,
  setErrorFromImage,
  ...props
}: InputProps): JSX.Element => {
  const [show, setShow] = useState(false);
  const { t } = useTranslation();
  const [image, setImage] = useState<any>('');
  const [inputFile, setInputFile] = useState<
    string | number | readonly string[] | undefined
  >();
  const imageExtensions = ['jpeg', 'jpg', 'png', 'svg', 'gif'];
  const upload = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!e.currentTarget.files) return;
    const file = e.currentTarget.files[0];
    const fileExtension = file?.name?.split('.').pop() || '';
    if (!imageExtensions.includes(fileExtension)) {
      setErrorFromImage(t('error.invalidImageFormat'));
      return;
    }
    if (Number(file?.size) > MAX_FILE_SIZE) {
      setErrorFromImage(t('error.invalidImageSize'));
      return;
    }

    const reader = new FileReader();
    reader.onloadend = () => {
      setImage(reader.result);
      changeImage(props.name || '', reader.result?.toString() || '');
    };
    reader.readAsDataURL(file);
    setImage(file);
    setShow(true);
  };
  const remove = () => {
    setImage(null);
    setShow(false);
    setInputFile('');
  };
  const refInputFile = useRef<any>();
  const reload = () => {
    (refInputFile.current as unknown as HTMLInputElement).click();
  };
  return (
    <div>
      <div className="h-[300px] bg-neutral-98 text-neutral-12 rounded-borderRadius10 p-6 py-6 ">
        <p className="mb-3">Logo ({t('field.optional')})</p>
        <div className="mb-3 ">
          <input
            className="opacity-0 z-[-1] "
            onChange={(e) => upload(e)}
            value={inputFile}
            id="my-file"
            type="file"
            accept="image/*"
            ref={refInputFile}
            hidden
          />
          <input type="text" {...props} hidden />
          <div className="flex gap-4">
            <MainButton
              onClick={reload}
              description={show ? t('field.update') : t('field.upload')}
              type="button"
              className="min-w-[100px] "
            />

            {show && (
              <MainButton
                onClick={remove}
                description={t('field.delete')}
                type="button"
                className="min-w-[100px] bg-red-00 text-white "
                variant="text"
              />
            )}
          </div>
        </div>
        <div className="border border-dashed rounded-borderRadius10 h-[160px] flex flex-col  justify-center ">
          <div className="self-center ">
            {show ? (
              <img
                src={image}
                alt="Logo"
                className="max-w-[calc(100%-4px)] max-h-[140px] "
              />
            ) : (
              t('field.noFileSelected')
            )}
          </div>
        </div>
      </div>
      {showError && (
        <div className="text-sm text-red-00 -my-6 mx-6 h-4  ">{error}</div>
      )}
    </div>
  );
};
